import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../axiosInstance";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import { useEffect, useState } from "react";
import { errorMessage, postUserLog } from "../hooks/UserLogs";
import ConfirmModal from "../components/confirmModal";
export default function LimitPerPaymentMethod() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListLimitPaymentMethods, setListLimitPaymentMethods] = useState([]);
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [isLoading, setIsLoading] = useState(true)
  const [showError, setShowError] = useState(false);
  const [errorForm, setErrorForm] = useState({});
  const [minAmount, setMinAmount] = useState(1);
  const [maxAmount, setMaxAmount] = useState(1000);
  const [idFee, setIdFee] = useState("")
   const [isActive, setIsActive] = useState(false);
  const [showModalConfirmActive, setShowModalConfirmActive] = useState(false);

  const bUrl = process.env.REACT_APP_B_URL;

  const axiosInstance = axios.create({
    withCredentials: true,
  }) 

  let header =
  {
    'Content-Type': 'application/json'
  };

  const navigate = useNavigate();

  const handleShowConfirmActive = (id, isActive) => {
        setShowModalConfirmActive(true);
        setIdFee(id);
        setIsActive(isActive);
    }
  
   const activeOrDeactiveUser = async () => {

        const response = await axiosInstance.put(bUrl + "/paymentMode/activate-or-deactivate", {
            "fkIdStaff": sessionStorage.getItem("idUser"),
            "idPaymentMode": idFee
        }).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
                setShowError(true);
              } else {
                let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
                seterrMsg(msg);
                setShowError(true);
              }
            setIsLoading(false)

            console.log(err);

        });
        if (response) {
           
            setIsLoading(false);
            handleCloseConfirmActive()
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                seterrMsg(msg);
                setShowError(true);
            } else {
                getListLimitPaymentMethod();
                await postUserLog(bUrl + "/userLogs/addUserLogs", (isActive) ? 'Activate payment Method' : 'Deactivate payment Method', response.data.body.login);
            }

        }

    }

  const handleCloseConfirmActive = () => setShowModalConfirmActive(false);
  const getListLimitPaymentMethod = async (e) => {
      let ulr = "/fee-send/find-all?page=" + currentPage + "&limit=10";
      
      const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
        
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          seterrMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        }else{
          let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
          seterrMsg(msg);
          setShowError(true);
        }
  
        setIsLoading(false)
  
      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        setListLimitPaymentMethods(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
        setIsLoading(false);
      }
    }

    const viewUpdate =(minAmount,maxAmount,idFee)=>{
      setMinAmount(minAmount);
      setMaxAmount(maxAmount);
      setIdFee(idFee);
      setView(true);
    }

    const handleClose = () => {
        setView(false);
    }

    const minAmountOnchange=(e) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
         setMinAmount(e.target.value)
      }
   }

   const maxAmountOnchange=(e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
       setMaxAmount(e.target.value)
    }
 }
    const updateLimitPerPaymentMethod=()=>{
      
      setIsLoading(true);
      axiosInstance.post(bUrl + "/fee-send/limit-update",
      
              //birthDay: birthDay,
              {
                "feeId": idFee,
                "minAmount": minAmount,
                "maxAmount": maxAmount,
                "fkIdStaff":sessionStorage.getItem("idUser")
              }
      
              , { header: header })
              .then(function (response) {
                //getDayOffDayEmmp(idEmp);
                setIsLoading(false)
      
                handleClose()
                if (response.data.isError) {
                  seterrMsg(response.data.msg);
                  setShowError(true);
                } else {
                  getListLimitPaymentMethod();
                }
      
              })
              .catch(function (err) {
                setIsLoading(false)
      
                if (err?.response?.status == 401 || err?.response?.status == 403) {
                  seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
                  setShowError(true);
                }else{
                  let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
                  seterrMsg(msg);
                  setShowError(true);
                }
              });
    }

    const handleCloseError = () => {
        setShowError(false);
      }
    

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
      }
      useEffect(() => {
        if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
          //console.log("----------GO GO GO ------------")
          navigate('/backoffice/login');
        }
        getListLimitPaymentMethod();
      }, [currentPage])

      return (
        <div className="App">
          <div className="">
    
    
            <Sidebar />
            <section className="home ">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-12">
                  <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                    <div><p className='fw-bold'>Limites</p></div>
                    <div><Topbar /></div>
                  </div>
                  <div className="table-content mt-3 p-3">
                    <div className="d-flex justify-content-around">
                      <div className="form-group text">
                        <label htmlFor="exampleInputEmail1">Email</label>
                        <input type="email" onChange={(e) => getListLimitPaymentMethod()} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                      </div>
                      <div className="form-group text">
                        <label htmlFor="phone">Phone</label>
                        <input type="text" onChange={(e) => getListLimitPaymentMethod()} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                      </div>
                      <div className="form-group text">
                        <label htmlFor="code">Code</label>
                        <input type="text" onChange={(e) => getListLimitPaymentMethod()} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                      </div>
                    </div>
                  </div>
                  <div className="table-content mt-3 p-3">
    
    
    
    
                    {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                    <div className="table-responsive-xl">
                      {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                        <table className="table text">
                          <thead>
                            <tr>
    
                              <th scope="col"></th>
                              <th scope="col">Montant minimum</th>
                              <th scope="col">Montant maximum</th>
                              <th scope="col">Methode de paiement</th>
                              <th scope="col">Date</th>
                              <th></th>
                              <th></th>
    
                            </tr>
                          </thead>
    
                          <tbody>
                            {ListLimitPaymentMethods.length > 0 ? ListLimitPaymentMethods.map((a, i) => {
                              return <tr key={i}>
                                <td>{i}</td>
                                <td>{a.minAmount}</td>
                                <td>{a.maxAmount}</td>
                                <td>{a?.paymentMode?.description}</td>
                                <td>{formatDate(a.createdDate)}</td>
                                <td>
                                  <label className="switch">
                                      <input type="checkbox" className="i-btn" checked={a.paymentMode?.status ? 'checked' : ''} onChange={(e) => handleShowConfirmActive(a.fkIdPaymentMode, e.target.checked)} />
                                      <span className="slider-btn round"></span>
                                  </label>
                                </td>
                                
                                <td>
                                  <i onClick={() => viewUpdate(a.minAmount,a.maxAmount,a.idFeeSend)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                                </td>
                                {/* <td><Link to={"/collections/"+a.hashids+"/byAgent/"}>Dépots</Link></td> */}
    
                              </tr>
                            }) : <tr></tr>}
                          </tbody>
    
                        </table>
                      }
                    </div>
                    <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                  </div>
    
                </div>
              </div>
            </section>
          </div>
          <Modal show={view} onHide={handleClose} className="">
            <Modal.Header closeButton>
              <Modal.Title className="text-center">Limit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
             
             <form>
                
             </form>
            </Modal.Body>
            <form>
              <div className="p-3">
            <div className="form-group mb-2">
              <input type="text" placeholder="0000" name="MinAmount" className='form-control ' value={minAmount} onChange={(e) => minAmountOnchange(e)} />
              {errorForm.firstNameUp != "" && <p style={{ color: 'red' }}>{errorForm.firstNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="0000" name="MinAmount" className='form-control ' value={maxAmount} onChange={(e) => maxAmountOnchange(e)} />
              {errorForm.firstNameUp != "" && <p style={{ color: 'red' }}>{errorForm.firstNameUp}</p>}
            </div>
            </div>
            </form>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {isLoading ?
                <img src='../Custom.svg' width="30%" />
                :
                <Button variant="primary" onClick={updateLimitPerPaymentMethod}>
                  Modifier
                </Button>
    
              }
            </Modal.Footer>
          </Modal>
    
          <ConfirmModal
                show={showModalConfirmActive}
                handleClose={handleCloseConfirmActive}
                handleConfirm={activeOrDeactiveUser}
            />
          {/* =============================================error=============================== */}
          <Modal show={showError} onHide={handleCloseError} className="">
            <Modal.Header closeButton className="bg-danger">
              <Modal.Title>ERROR</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseError}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )
    }
